import { useContext } from "react";
import "./index.css";
import { AppContext } from "../../context/AppContext";

const TrustedByStudents = () => {
  const { trustedByStudents } = useContext(AppContext);
  return (
    <section className="iit-logo-bg-container" ref={trustedByStudents}>
      <div className="container d-flex align-items-center">
        <img
          src="https://iqteche.in/static/media/wl_client_images/d858ae5a18cf42669ea75236aa96119a.png"
          alt="graduated"
          className="graduate-img d-none d-xl-block"
        />
        <div className="iit-logo-container text-center ">
          <h1 className="trusted-by-heading">Trusted By Students From</h1>
          <div className="iit-imgs-container">
            <img
              src="https://iqteche.in/static/media/wl_client_images/22f6219dcff84598bc8a1393aca5320c.png"
              alt="iit-kharagpur"
              className="iit-img kharagpur-iit-logo"
            />
            <img
              src="https://iqteche.in/static/media/wl_client_images/b7c18f8d8bf64d0e92b3573b5fdeb437.png"
              alt="NIT"
              className="iit-img"
            />
            <img
              src="https://iqteche.in/static/media/wl_client_images/18799ad1523d426a85e2954b46fca0a7.png"
              alt="SRM University"
              className="iit-img"
            />
            <img
              src="https://iqteche.in/static/media/wl_client_images/f38958d715c44d84baa18a91057f8a7b.png"
              alt="VIT"
              className="iit-img"
            />
            <img
              src="https://iqteche.in/static/media/wl_client_images/e0d60ed1cc554c80b82eb5fd16f7a67a.png"
              alt="BITS Pilani"
              className="iit-img"
            />
          </div>
        </div>

        <img
          src="https://iqteche.in/static/media/wl_client_images/45d216037e0e4178b7b52d3e31de4dd8.png"
          alt="graduated"
          className="graduate-img d-none d-xl-block"
        />
      </div>
    </section>
  );
};

export default TrustedByStudents;
